import React, { useEffect, useState } from "react";
import { Bell } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";

export default function NotificationBell() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({ items: [], unread: 0 });

  const refresh = async () => {
    if (!user) return;
    try { const { data } = await api.get("/me/notifications"); setData(data); } catch {}
  };
  useEffect(() => { refresh(); const t = setInterval(refresh, 30000); return () => clearInterval(t); }, [user]);

  if (!user) return null;
  const markAll = async () => { await api.post("/me/notifications/read-all"); refresh(); };
  const markOne = async (id) => { await api.post(`/me/notifications/${id}/read`); refresh(); };

  return (
    <div className="relative">
      <button data-testid="notif-bell" onClick={() => setOpen((v) => !v)} className="relative p-2 hover:text-squire-jeans transition-colors" aria-label="notifications">
        <Bell size={20} />
        {data.unread > 0 && <span className="absolute -top-1 -right-1 bg-squire-jeans text-white text-[10px] w-4 h-4 flex items-center justify-center rounded-full">{data.unread}</span>}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-80 bg-white border border-black/10 shadow-xl z-[60]" data-testid="notif-panel">
          <div className="flex items-center justify-between px-4 py-3 border-b border-black/10">
            <div className="font-display text-lg">Notifications</div>
            {data.unread > 0 && <button data-testid="notif-mark-all" onClick={markAll} className="text-[10px] uppercase tracking-[0.2em] text-squire-jeans">Mark all read</button>}
          </div>
          <div className="max-h-96 overflow-y-auto sq-scroll">
            {data.items.length === 0 && <div className="p-6 text-sm text-[#4B5563]">No notifications yet.</div>}
            {data.items.map((n) => (
              <button key={n.id} data-testid={`notif-${n.id}`} onClick={() => { markOne(n.id); if (n.link) window.location = n.link; }} className={`block w-full text-left px-4 py-3 border-b border-black/5 hover:bg-[#F5F5F5] ${!n.read ? "bg-[#FAFAFA]" : ""}`}>
                <div className="flex justify-between gap-2">
                  <div className="font-display text-sm">{n.title}</div>
                  {!n.read && <span className="w-2 h-2 rounded-full bg-squire-jeans mt-1" />}
                </div>
                <div className="text-xs text-[#4B5563] mt-1">{n.body}</div>
                <div className="sq-eyebrow text-[9px] mt-2 text-[#4B5563]">{n.kind} · {n.created_at?.slice(0, 16).replace("T", " ")}</div>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
